import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStar"><Path d="M15.4052 7.31329L12.0002 0.177734L8.59533 7.31329L0.756836 8.34655L6.49098 13.7898L5.05144 21.564L12.0002 17.7926L18.9491 21.564L17.5095 13.7898L23.2437 8.34655L15.4052 7.31329Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStar;
